/**
 * WindyWeatherWidget - Displays Windy weather embed for hikes
 *
 * Only shows if:
 * - Hike has coordinates (latitude and longitude)
 * - Hike start date is within X days from now
 *
 * @param {number|null} latitude - Hike latitude
 * @param {number|null} longitude - Hike longitude
 * @param {string} dataInizio - Hike start date (ISO string or YYYY-MM-DD)
 */
export default function WindyWeatherWidget({ latitude, longitude, dataInizio }) {
  // Check if coordinates are available
  if (!latitude || !longitude) {
    return null;
  }

  // Check if hike is within X days
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const hikeDate = new Date(dataInizio);
  hikeDate.setHours(0, 0, 0, 0);

  const diffTime = hikeDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  // Show only if hike is in the future and within X days
  if (diffDays < 0 || diffDays > 5) {
    return null;
  }
  const iframeSrc = `https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=11&overlay=rain&product=ecmwf&level=surface&lat=${latitude}&lon=${longitude}&message=true`;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 bg-blue-50 border-b border-blue-100">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-blue-800 flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
            </svg>
            <span>Mappa precipitazioni</span>
          </h3>
        </div>
      </div>
      <div className="relative" style={{ paddingBottom: '100%', minHeight: '300px' }}>
        <iframe
          title="Windy Weather"
          src={iframeSrc}
          frameBorder="0"
          className="absolute inset-0 w-full h-full"
          loading="lazy"
        />
      </div>
    </div>
  );
}
